import { Navigate } from "react-router-dom";
import { ReactElement, ReactNode } from "react";
import { useAuth } from "../context/AuthContext";

interface Props {
  children: ReactNode;
}

export default function ProtectedRoute({
  children,
}: Props): ReactElement {
  const { user, isHydrated } = useAuth();

  if (!isHydrated) {
    return <></>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}